export enum RouteEnum {
  HOME = "/",
  SIGN_IN = "/sign-in",
  SIGN_UP = "/sign-up",
  INVITE = "/invite",
  REQUESTS = "/requests",
  PROPOSALS = "/proposals",
  MY_WORKSPACE = "/my-workspace",
  FORGOT_PASSWORD = "/forgot-password",
  CONTACT_US = "/contact-us",
  SETTINGS = "/settings",
  SEND_NOTIFICATION = "/send-notification",
}
